import React from 'react'
import { Button, Form, FormGroup, Input, InputGroup, Label } from 'reactstrap'
import Loader from 'react-loader-spinner'
import '../../stylesheets/odometer-theme-default.css'
import { subscriptionHelpers } from '../../dataHelpers'
import { getStorage, TOKEN_STORAGE_KEY } from '../../dataHelpers/authenticationHelpers'
import '../../stylesheets/ControllerDashboard.css'
import AppError from "../../models/AppError"
import { getAllTeams } from "../../api"
import { ErrorModal } from './../ui'
import { SUCCESS, NO_TEAM_SELECT, NO_DISCOUNT_LABEL_SELECT, SELECT_TEAM, SELECT_DISC_LABEL, 
    ASSIGN_DISCOUNT_SUCCESS } from '../../constants'

class AssignDiscount extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: true,
            discountId: '',
            teamId: '',
            discountLabelList: [],
            teams: []
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.submitForm = this.submitForm.bind(this)
        this.fetchTeamsState = this.fetchTeamsState.bind(this)
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    componentDidMount() {
        this.getDiscountList(this.token)
        this.fetchTeamsState(this.token)
    }

    async fetchTeamsState(token) {
        try {
            let { results } = await getAllTeams(token, 1, true, false, true, 1, 10000)
            this.setState({ teams: results, loading: false })
        } catch (error) {
            console.log(error)
        }
    }

    async getDiscountList(token) {
        try {
            let discountData = await subscriptionHelpers.getDiscountLabelList(token)
            if (!discountData.error) {
                discountData = discountData.filter(e => e.is_active == true)
                this.setState({ discountLabelList: discountData })
            } else {
                this.setState({ errors: [discountData.error] })
            }
        } catch (error) {
            console.log(error)
        }
    }

    async submitForm(e) {
        e.preventDefault()
        this.setState({ loading: true })
        let { teamId, discountId } = this.state

        if (!teamId || teamId == '') {
            let appError = new AppError(NO_TEAM_SELECT, SELECT_TEAM)
            await this.setState({ errors: [appError], loading: false })
            return
        }
        if (!discountId || discountId == '') {
            let appError = new AppError(NO_DISCOUNT_LABEL_SELECT, SELECT_DISC_LABEL)
            await this.setState({ errors: [appError], loading: false })
            return
        }
        let createDiscountResponse = await subscriptionHelpers.assignSubsDiscount(this.token, teamId, discountId)
        if (!createDiscountResponse.error) {
            let appError = new AppError(SUCCESS, ASSIGN_DISCOUNT_SUCCESS)
            await this.setState({ errors: [appError], loading: false, discountId: '' })
            return
        } else {
            this.setState({ errors: [createDiscountResponse.error] })
        }
    }

    render() {
        let { loading, errors, discountId, discountLabelList, teams } = this.state

        return (<div>
            <div className="row justify-content-center align-items-center bg-light large-rounded border-light-sf-orange p-0 pb-4">
                <h1 className="text-center mb-4 form-head col-12">Assign Discount Level to Dealer Team</h1>
                {loading ?
                    <Loader type="TailSpin" width={60} height={60} /> :
                    <Form onSubmit={this.submitForm} className="col-lg-6 col-md-8 col-sm-10">
                        <FormGroup>
                            <br />
                            <div>
                                <div className="text-left">
                                    <Label>Team</Label>
                                    <InputGroup>
                                        <Input type="select" name="selectTeam"
                                            onChange={(evt) => this.setState({ teamId: evt.target.value })}
                                        >
                                            <option value="">&ensp;Select Team</option>
                                            {(teams && teams.length > 0) ? teams.map((team, idx) => (
                                                <option key={`${team.id}-${idx}`}
                                                    value={team.id}>{team.id}&ensp;&mdash;&ensp;{team.name}</option>
                                            )) : ''
                                                // <option>&ensp;No Team</option>
                                            }
                                        </Input>
                                    </InputGroup>
                                </div>
                                <br />
                                <div className="text-left">
                                    <Label>Discount</Label>
                                    <InputGroup>
                                        <Input type="select" name="discountval"
                                            onChange={(evt) => this.setState({ discountId: evt.target.value })}
                                        >
                                            <option value="">&ensp;Select Discount Label</option>
                                            {(discountLabelList && discountLabelList.length > 0) ? discountLabelList.map((dis) => (
                                                <option key={`${dis.id}`}
                                                    value={dis.id}>&ensp;{dis.discount_label}</option>
                                            )) :
                                                <option>&ensp;No Discount</option>
                                            }
                                        </Input>
                                    </InputGroup>
                                </div>
                            </div>
                        </FormGroup>
                        <Button className="mt-3">Assign</Button>
                    </Form>
                }
                {errors.map((appError, idx) =>
                    <ErrorModal key={`error-${appError.text}-${idx}`}
                        modal={true}
                        toggle={() => (this.dismissError(appError))}
                        text={appError.text}
                        title={appError.title} />
                )}
            </div>
        </div>)
    }
}
export default AssignDiscount



// WEBPACK FOOTER //
// ./src/components/ui/AssignDiscount.js